
import React, { useEffect, useState, } from 'react';
import { ViewMode, Gantt, Task } from "gantt-task-react";
import TimeControl from "./TimeControl";
import { useApp, useUser } from 'hooks';
import { ETaskActions, ETypeTaskGantt } from 'types';
import { formatDMYInd, formatYMD, hexToRgba, prepareDate, sliceString } from 'utils';

const getProject = (defaultProject) => ({
  start: prepareDate(defaultProject?.start_date),
  end: prepareDate(defaultProject?.due_date),
  name: (defaultProject?.name).toUpperCase(),
  id: defaultProject?.code,
  type: ETypeTaskGantt.PROJECT,
  status: 'open',
  progress: defaultProject?.percent,
  isDisabled: false,
  hideChildren: false,
  styles: { backgroundColor: hexToRgba('#3b82f6', 0.7), backgroundSelectedColor: '#3b82f6' },
});

const getTask = (taskItem, defaultProject) => ({
  start: prepareDate(taskItem.start_date),
  end: prepareDate(taskItem.due_date),
  name: taskItem.title,
  id: taskItem.id,
  type: taskItem.type,
  status: taskItem.status,
  progress: taskItem?.progress,
  project: defaultProject?.code,
  dependencies: taskItem?.parents_id ? [taskItem?.parents_id] : [],
  styles: { progressColor: 'blue', progressSelectedColor: 'blue' },
});

const TaskGantt = ({ dataTasks = null, onAction }) => {
  const { data: listData } = dataTasks || {
    data: []
  };
  const { defaultProject } = useUser();
  const { taskFilter } = useApp()
  console.log("🚀 ~ TaskGantt ~ defaultProject:", defaultProject)
  const [tasks, setTasks] = useState<Task[]>([]);
  const [view, setView] = useState<ViewMode>(ViewMode.Day);

  useEffect(() => {
    if (listData?.length && defaultProject) {
      const listTasks = listData.map(el => getTask(el, defaultProject));
      setTasks([getProject(defaultProject), ...listTasks])
    }
  }, [listData, defaultProject]);

  const handleDrop = (opts) => {
    // e.preventDefault();
    onAction?.(ETaskActions.UPDATE, {
      project_id: defaultProject?.id,
      ...opts
    });
  };

  const filteredTasks = tasks.filter(task => {
    // const matchesSearch = task.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   task.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = taskFilter.status === 'all' || task?.['status'] === taskFilter.status;//taskFilter.status === 'all' ||  || task.priority === taskFilter.priority;
    return matchesFilter;
  });

  return (
    <div className="min-h-screen bg-white">
      {!!filteredTasks.length && <div className="flex justify-between items-center pt-6 px-6">
        <div></div>
        <div className="flex gap-2">
          <TimeControl onChangeView={setView} />
        </div>
      </div>}
      <div className="max-w-screen mx-auto py-6 overflow-hidden" style={{ maxWidth: 'calc(100vw - 180px)' }}>
        {!!filteredTasks.length &&
          <div className='flex'>
            {/* Bảng custom bên trái */}
            <div style={{ minWidth: 500, borderRight: "1px solid #ccc", flex: 1 }}>
              <div className='flex flex-row items-center' style={{ fontWeight: "bold", padding: "4px 8px", background: "#f9f9f9", borderBottom: "1px solid #eee", height: 50 }}>
                <div style={{ flex: 2 }}>Tên</div>
                <div style={{ flex: 1 }}>Từ ngày</div>
                <div style={{ flex: 1 }}>Đến này</div>
              </div>
              {filteredTasks.map((task) => (
                <div key={task.id} style={{ display: "flex", padding: "4px 8px", borderBottom: "1px solid #eee", height: 50 }}>
                  <div style={{ flex: 2 }} className={`${task.type === 'milestone' ? 'font-bold text-[orange]' : ''}`}>
                    {sliceString(task.name, 25)}

                  </div>
                  <div style={{ flex: 1 }} className={`${task.type === 'milestone' ? 'font-bold text-[orange]' : ''}`}>{`${formatDMYInd(`${task.start}`, '-')} `}</div>
                  <div style={{ flex: 1 }} className={`${task.type === 'milestone' ? 'font-bold text-[orange]' : ''}`}>{formatDMYInd(`${task.end}`, '-')}</div>
                </div>
              ))}
            </div>

            {/* Phần gantt chart bên phải */}
            <div style={{ flex: 1, maxWidth: 'calc(100vw - 200px)' }}>
              <Gantt
                tasks={filteredTasks}
                viewMode={view}
                listCellWidth=""
                onDateChange={(task) => {
                  handleDrop({
                    id: task.id,
                    start_date: formatYMD(`${task.start.toDateString()}`),
                    due_date: formatYMD((task.end).toDateString()),
                  })
                  setTasks(prev =>
                    prev.map(t => (t.id === task.id ? task : t))
                  );
                }}
              // onProgressChange={(task) => {
              //   console.log("🚀 ~ task:onProgressChange", task)
              //   setTasks(prev =>
              //     prev.map(t => (t.id === task.id ? task : t))
              //   );
              // }}
              />
            </div>
          </div>}

      </div>
      <div className="flex"></div>
    </div>
  );
}
export default TaskGantt;